<template>
  <div>
    <div class="vx-row w-full">
      <div class="vx-col w-1/4 position-relative">
        <div class="text-right trial-buttons" id="myDIV">
          <button @click="changeFreeTrialData('day')" class="font-bold text-grey p-1 btn active">Day</button>
          <button @click="changeFreeTrialData('week')" class="font-bold text-grey p-1 btn">Week</button>
          <button @click="changeFreeTrialData('month')" class="font-bold text-grey p-1 btn">Month</button>
        </div>
        <div class="settings">
          <feather-icon icon="SettingsIcon" @click="openGraph('1')" class></feather-icon>
        </div>
        <statistics-card-line
          class="trial-card"
          icon="UserIcon"
          :statistic="statisticFreeTrial"
          :statisticOne="freeTrialWonCount"
          :statisticTwo="freeTrialLostCount"
          :statisticTitle="'Active Free Trials'"
          :statisticTitleOne="'Won'"
          :statisticTitleTwo="'Lost'"
          type="area"
          :chartData="freeTrialData"
          color="primary"
        />
      </div>
      <div class="vx-col w-1/4 position-relative" id="revenue">
        <div class="text-right trial-buttons">
          <button
            @click="changeRevenueData('day')"
            class="font-bold text-grey p-1 revenue-btn revenue-active"
          >Day</button>
          <button
            @click="changeRevenueData('week')"
            class="font-bold text-grey p-1 revenue-btn"
          >Week</button>
          <button
            @click="changeRevenueData('month')"
            class="font-bold text-grey p-1 revenue-btn"
          >Month</button>
        </div>
        <div class="settings">
          <feather-icon icon="SettingsIcon" @click="openGraph('2')" class></feather-icon>
        </div>
        <statistics-card-line
          class="trial-card"
          icon="DollarSignIcon"
          :statistic="statisticRevenue"
          :statisticOne="revenueNewCount"
          :statisticTwo="revenueRecurringCount"
          :statisticTitle="'Revenue Generated'"
          :statisticTitleOne="'New'"
          :statisticTitleTwo="'Recurring'"
          type="area"
          :chartData="revenueData"
          color="success"
        />
      </div>
      <div class="vx-col w-1/4 position-relative" id="sales">
        <div class="text-right trial-buttons">
          <button
            @click="changeSalesData('day')"
            class="font-bold text-grey p-1 sales-btn sales-active"
          >Day</button>
          <button @click="changeSalesData('week')" class="font-bold text-grey p-1 sales-btn">Week</button>
          <button @click="changeSalesData('month')" class="font-bold text-grey p-1 sales-btn">Month</button>
        </div>
        <div class="settings">
          <feather-icon icon="SettingsIcon" @click="openGraph('3')" class></feather-icon>
        </div>
        <statistics-card-line
          class="trial-card"
          icon="ShoppingCartIcon"
          :statistic="staticSales"
          :statisticOne="salesWonCount"
          :statisticTwo="salesLostCount"
          :statisticTitle="'Sales'"
          :statisticTitleOne="'New'"
          :statisticTitleTwo="'Recurring'"
          type="area"
          :chartData="salesData"
          color="danger"
        />
      </div>
      <div class="vx-col w-1/4 position-relative">
        <div class="settings">
          <feather-icon icon="SettingsIcon" @click="openGraph('4')" class></feather-icon>
        </div>
        <statistics-card-line
          class="trial-card"
          icon="ShoppingBagIcon"
          :statistic="plan.totalCustomersData.totalCustomers"
          :statisticOne="plan.totalCustomersData.totalNewCustomers"
          :statisticTwo="plan.totalCustomersData.totalOldCustomers"
          :statisticTitle="'Customers'"
          :statisticTitleOne="'New'"
          :statisticTitleTwo="'Recurring'"
          type="area"
          :chartData="customerData"
          color="warning"
        />
      </div>
      <template slot="codeContainer"></template>
    </div>
    <div class="vx-row w-full m-0 mt-6" v-if="flag == true">
      <div class="vx-col w-full position-relative vx-card p-6">
        <label class="font-bold text-2xl">{{graphLabel}}</label>
        <div class="flex mt-4">
          <div class="mr-4">
            <span class="font-bold">This Month</span>
            <h2 class="text-success">
              <sup class="text-sm">$</sup>
              {{currentMonth}}
            </h2>
          </div>
          <div>
            <span class="font-bold">Last Month</span>
            <h2>
              <sup class="text-sm">$</sup>
              {{lastMonth}}
            </h2>
          </div>
        </div>
        <div id="chart">
          <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

export default {
  components: {
    StatisticsCardLine
  },

  data() {
    return {
      graphLabel: "",
      currentMonth: 0,
      lastMonth: 0,
      flag: false,
      series: [
        {
          name: "Session Duration",
          data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10]
        },
        {
          name: "Page Views",
          data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#FF1654", "#626262"],
        stroke: {
          curve: "smooth",
          dashArray: [0, 7]
        },
        // title: {
        //   text: "Last Month",
        //   align: "left"
        // },
        legend: {
          tooltipHoverFormatter: function(val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"]
        },

        grid: {
          borderColor: "#f1f1f1"
        }
      },
      statisticFreeTrial: 0,
      freeTrialWonCount: 0,
      freeTrialLostCount: 0,
      day: null,
      week: null,
      month: null,
      statisticRevenue: 0,
      revenueNewCount: 0,
      revenueRecurringCount: 0,
      staticSales: 0,
      salesWonCount: 0,
      salesLostCount: 0,
      options: {},
      input: {},
      plan: null,
      analyticsData: [],
      dashboardData: [],
      graphDataDay: [],
      freeTrialData: [
        {
          name: "",
          data: []
        }
      ],
      revenueData: [
        {
          name: "",
          data: []
        }
      ],
      salesData: [
        {
          name: "",
          data: []
        }
      ],
      customerData: [
        {
          name: "",
          data: []
        }
      ]
    };
  },
  watch: {},
  mounted() {
    this.getDashboardData();
  },
  computed: {},
  methods: {
    changeFreeTrialData(selected) {
      // Add active class to the current button (highlight it)
      var header = document.getElementById("myDIV");
      var btns = header.getElementsByClassName("btn");
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener("click", function() {
          var current = document.getElementsByClassName("active");
          current[0].className = current[0].className.replace(" active", "");
          this.className += " active";
        });
      }
      if (selected == "day") {
        this.statisticFreeTrial = 0;
        this.freeTrialWonCount = 0;
        this.freeTrialLostCount = 0;
        this.freeTrialData = [{ name: "", data: [] }];
        this.statisticFreeTrial = this.day.freeActivePlanCountOfDay;
        this.freeTrialWonCount = this.day.wonCountOfDay;
        this.freeTrialLostCount = this.day.lostCountOfDay;
        var data = this.plan.dataOfActivePlanDays.countGraphDataDay.map(
          g => g.count
        );
        this.freeTrialData[0].data = data;
      } else if (selected == "week") {
        this.statisticFreeTrial = 0;
        this.freeTrialWonCount = 0;
        this.freeTrialLostCount = 0;
        this.freeTrialData = [{ name: "", data: [] }];
        this.statisticFreeTrial = this.week.freeActivePlanCountOfWeek;
        this.freeTrialWonCount = this.week.wonCountOfWeek;
        this.freeTrialLostCount = this.week.lostCountOfWeek;
        var data = this.plan.dataOfActivePlanWeeek.countGraphDataWeek.map(
          g => g.count
        );
        this.freeTrialData[0].data = data;
      } else {
        this.statisticFreeTrial = 0;
        this.freeTrialWonCount = 0;
        this.freeTrialLostCount = 0;
        this.freeTrialData = [{ name: "", data: [] }];
        this.statisticFreeTrial = this.month.freeActivePlanCountOfMonth;
        this.freeTrialWonCount = this.month.wonCountOfMonth;
        this.freeTrialLostCount = this.month.lostCountOfMonth;
        var data = this.plan.dataOfActivePlanMonth.countGraphDataMonth.map(
          g => g.count
        );
        this.freeTrialData[0].data = data;
      }
    },
    changeRevenueData(selected) {
      // Add active class to the current button (highlight it)
      var header = document.getElementById("revenue");
      var btns = header.getElementsByClassName("revenue-btn");
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener("click", function() {
          var current = document.getElementsByClassName("revenue-active");
          current[0].className = current[0].className.replace(
            " revenue-active",
            ""
          );
          this.className += " revenue-active";
        });
      }
      if (selected == "day") {
        this.statisticRevenue = 0;
        this.revenueNewCount = 0;
        this.revenueRecurringCount = 0;
        this.revenueData = [{ name: "", data: [] }];
        this.statisticRevenue = this.plan.totalRevenueTodayOfSale.totalRevenueCountDayOfSale;
        this.revenueNewCount = this.plan.totalRevenueTodayOfSale.totalRevenueTodayOfNewSale;
        this.revenueRecurringCount = this.plan.totalRevenueTodayOfSale.totalRevenueTodayOfOldSale;
        var data = this.plan.totalRevenueTodayOfSale.revenueGraphDataDay.map(
          g => g.revenue
        );
        this.revenueData[0].data = data;
      } else if (selected == "week") {
        this.statisticRevenue = 0;
        this.revenueNewCount = 0;
        this.revenueRecurringCount = 0;
        this.revenueData = [{ name: "", data: [] }];
        this.statisticRevenue = this.plan.totalRevenueWeekOfSale.totalRevenueCountWeekOfSale;
        this.revenueNewCount = this.plan.totalRevenueWeekOfSale.totalRevenueWeekOfNewSale;
        this.revenueRecurringCount = this.plan.totalRevenueWeekOfSale.totalRevenueWeekOfOldSale;
        var data = this.plan.totalRevenueWeekOfSale.revenueGraphDataWeek.map(
          g => g.revenue
        );
        this.revenueData[0].data = data;
      } else {
        this.statisticRevenue = 0;
        this.revenueNewCount = 0;
        this.revenueRecurringCount = 0;
        this.revenueData = [{ name: "", data: [] }];
        this.statisticRevenue = this.plan.totalRevenueMonthOfSale.totalRevenueCountMonthOfSale;
        this.revenueNewCount = this.plan.totalRevenueMonthOfSale.totalRevenueMonthOfNewSale;
        this.revenueRecurringCount = this.plan.totalRevenueMonthOfSale.totalRevenueMonthOfOldSale;
        var data = this.plan.totalRevenueMonthOfSale.revenueGraphDataMonth.map(
          g => g.revenue
        );
        this.revenueData[0].data = data;
      }
    },
    changeSalesData(selected) {
      // Add active class to the current button (highlight it)
      var header = document.getElementById("sales");
      var btns = header.getElementsByClassName("sales-btn");
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener("click", function() {
          var current = document.getElementsByClassName("sales-active");
          current[0].className = current[0].className.replace(
            " sales-active",
            ""
          );
          this.className += " sales-active";
        });
      }
      if (selected == "day") {
        this.statisticSales = 0;
        this.salesWonCount = 0;
        this.salesLostCount = 0;
        this.salesData = [{ name: "", data: [] }];
        this.statisticSales = this.plan.totalSaleDataToday.totalSaleDataTodayOfNewUsers;
        this.salesWonCount = this.plan.totalSaleDataToday.totalSaleDataTodayOfNewUsers;
        this.salesLostCount = this.plan.totalSaleDataToday.totalSaleDataTodayOfOldUsers;
        var data = this.plan.totalSaleDataToday.saleGraphDataDay.map(
          g => g.count
        );
        this.salesData[0].data = data;
      } else if (selected == "week") {
        this.statisticSales = 0;
        this.salesWonCount = 0;
        this.salesLostCount = 0;
        this.salesData = [{ name: "", data: [] }];
        this.statisticSales = this.plan.totalSaleDataWeek.totalSaleDataWeekOfNewUsers;
        this.salesWonCount = this.plan.totalSaleDataWeek.totalSaleDataWeekOfNewUsers;
        this.salesLostCount = this.plan.totalSaleDataWeek.totalSaleDataWeekOfOldUsers;
        var data = this.plan.totalSaleDataWeek.saleGraphDataWeek.map(
          g => g.count
        );
        this.salesData[0].data = data;
      } else {
        this.statisticSales = 0;
        this.salesWonCount = 0;
        this.salesLostCount = 0;
        this.salesData = [{ name: "", data: [] }];
        this.statisticSales = this.plan.totalSaleDataMonth.totalSaleDataMonthOfNewUser;
        this.salesWonCount = this.plan.totalSaleDataMonth.totalSaleDataMonthOfNewUser;
        this.salesLostCount = this.plan.totalSaleDataMonth.totalSaleDataMonthOfOldUser;
        var data = this.plan.totalSaleDataMonth.saleGraphDataMonth.map(
          g => g.count
        );
        this.salesData[0].data = data;
      }
    },
    async getDashboardData() {
      this.$vs.loading({
        color: "primary"
      });
      let url = "/user/dashboard";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          this.plan = response.data.data;
          this.day = this.plan.dataOfActivePlanDays;
          this.week = this.plan.dataOfActivePlanWeeek;
          this.month = this.plan.dataOfActivePlanMonth;
          setTimeout(() => {
            this.changeFreeTrialData("day");
            this.changeRevenueData("day");
            this.changeSalesData("day");
          }, 2000);
          var data = this.plan.totalCustomersData.customersGraphDataMonth.map(
            g => g.count
          );
          this.customerData[0].data = data;
          this.flag = true;
          this.openGraph("2");
        })
        .catch(e => {
          this.showError(e);
        });
    },
    openGraph(selected) {
      if (selected == "1") {
        this.graphLabel = "";
        this.currentMonth = 0;
        this.lastMonth = 0;
        this.flag = true;
        this.graphLabel = "Free Trials";
        this.currentMonth = this.plan.dataOfActivePlanMonth.freeActivePlanCountOfMonth;
        this.lastMonth = this.plan.dataOfActivePlanMonth.freeActivePlanCountOfLastMonth;
        this.series = [
          {
            name: "Current Month",
            data: []
          },
          {
            name: "Last Month",
            data: []
          }
        ];
        var dataOne = this.plan.dataOfActivePlanWeeek.countGraphDataWeek.map(
          g => g.count
        );
        var dataTwo = this.plan.dataOfActivePlanWeeek.countGraphDataWeekLastMonth.map(
          g => g.count
        );
        this.series[0].data = dataOne;
        this.series[1].data = dataTwo;
      } else if (selected == "2") {
        this.graphLabel = "";
        this.currentMonth = 0;
        this.lastMonth = 0;
        this.flag = true;
        this.graphLabel = "Revenue";
        this.currentMonth = this.plan.totalRevenueMonthOfSale.totalRevenueCountMonthOfSale;
        this.lastMonth = this.plan.totalRevenueMonthOfSale.totalRevenueLastMonthOfSale;
        this.series = [
          {
            name: "Current Month",
            data: []
          },
          {
            name: "Last Month",
            data: []
          }
        ];
        var dataOne = this.plan.totalRevenueWeekOfSale.revenueGraphDataWeek.map(
          g => g.revenue
        );
        var dataTwo = this.plan.totalRevenueWeekOfSale.revenueGraphDataWeekLastMonth.map(
          g => g.revenue
        );
        this.series[0].data = dataOne;
        this.series[1].data = dataTwo;
      } else if (selected == "3") {
        this.graphLabel = "";
        this.currentMonth = 0;
        this.lastMonth = 0;
        this.flag = true;
        this.graphLabel = "Sales";
        this.currentMonth = this.plan.totalSaleDataMonth.totalSaleMonth;
        this.lastMonth = this.plan.totalSaleDataMonth.totalSaleLastMonth;
        this.series = [
          {
            name: "Current Month",
            data: []
          },
          {
            name: "Last Month",
            data: []
          }
        ];
        var dataOne = this.plan.totalSaleDataWeek.saleGraphDataWeek.map(
          g => g.count
        );
        var dataTwo = this.plan.totalSaleDataWeek.saleGraphDataWeekLastMonth.map(
          g => g.count
        );
        this.series[0].data = dataOne;
        this.series[1].data = dataTwo;
      } else {
        this.graphLabel = "";
        this.currentMonth = 0;
        this.lastMonth = 0;
        this.flag = true;
        this.graphLabel = "Customers";
        this.currentMonth = this.plan.totalCustomersData.totalCustomersThisMonth;
        this.lastMonth = this.plan.totalCustomersData.totalCustomersLastMonth;
        this.series = [
          {
            name: "Current Month",
            data: []
          },
          {
            name: "Last Month",
            data: []
          }
        ];
        var dataOne = this.plan.totalCustomersData.customersGraphDataWeekMonth.map(
          g => g.count
        );
        var dataTwo = this.plan.totalCustomersData.customersGraphDataWeekLastMonth.map(
          g => g.count
        );
        this.series[0].data = dataOne;
        this.series[1].data = dataTwo;
      }
    }
  }
};
</script>
<style scoped>
.blue-border.trial-card {
  border: none !important;
  position: relative;
}
.trial-buttons {
  position: absolute;
  top: 5px;
  right: 22px;
  z-index: 10;
}
button,
button:hover {
  cursor: pointer;
  border: none;
  background: transparent;
}
.text-grey {
  color: #626262 !important;
}
.active,
.sales-active,
.revenue-active,
.btn:hover,
.sales-btn:hover,
.revenue-btn:hover {
  color: #0057ff !important;
}
.settings {
  position: absolute;
  bottom: 0px;
  right: 21px;
  cursor: pointer;
  z-index: 1;
}
</style>